import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import * as _ from "lodash";
import { DialogLinkObjectComponent } from "../dialog-link-object/dialog-link-object.component";

@Component({
  selector: "ngx-view-selection-object",
  styleUrls: ["./view-selection-object.component.scss"],
  templateUrl: "./view-selection-object.component.html",
})
export class ViewSelectionObjectComponent implements OnInit, OnDestroy {
  private alive = true;

  @Output() objectChange = new EventEmitter<any>();
  @Input() mode?: string;
  @Input() shopId?: string;
  @Input() objectType?: string = ""; //customer/supplier/employee/user
  @Input() objectId?: string = "";
  @Input() objectName?: string = "";
  @Input() objectValue: any;
  @Input() objects: any[] = [];
  @Input() title?: string = "";
  @Input() prefix?: string = "";
  @Input() allowCreate?: boolean = true;

  constructor(private dialogService: NbDialogService) {}

  ngOnInit(): void {
    if (!this.title || this.title === "") {
      switch (this.objectType) {
        case "customer":
          this.title = "Chọn khách hàng";
          this.prefix = "KH";
          break;
        case "supplier":
          this.title = "Chọn nhà cung cấp";
          this.prefix = "NCC";
          break;
        case "employee":
          this.title = "Chọn nhân viên";
          this.prefix = "NV";
          break;
        case "project":
          this.title = "Chọn dự án";
          this.prefix = "Dự án";
          break;
        case "user":
          this.title = "Chọn tài khoản";
          this.prefix = "TK";
          break;

        default:
          this.title = "Chọn đối tượng";
          this.prefix = "ĐT";
          break;
      }
    }
  }

  ngOnDestroy() {
    this.alive = false;
  }

  selectObject() {
    this.dialogService
      .open(DialogLinkObjectComponent, {
        context: {
          header: `Xin vui lòng chọn`,
          shopId: this.shopId,
          linkObjectId: this.objectId,
          objectType: this.objectType,
          objects: this.objects,
          allowCreate: this.allowCreate,
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.objectId = value.id;
          let objectName =
            this.objectType === "project" ? value.title : value.fullName;
          this.objectName = objectName ? objectName : "";
          this.objectValue = value;
          this.emitChange();
        }
      });
  }

  clearObject() {
    this.objectId = "";
    this.objectName = "";
    this.objectValue = null;
    this.emitChange();
  }

  emitChange() {
    this.objectChange.emit({
      objectId: this.objectId,
      objectName: this.objectName,
      objectType: this.objectType,
      objectValue: this.objectValue,
    });
  }
}
